"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WebhookUtils {
    static getReadEntityUrl(baseUrl, requiredQueryStrings, entityName, entityKey, taskHubName, connectionName) {
        let requestUrl = baseUrl + "/entities/" + entityName + "/" + entityKey + "?";
        const queryStrings = [];
        if (taskHubName) {
            queryStrings.push("taskHub=" + taskHubName);
        }
        if (connectionName) {
            queryStrings.push("connection=" + connectionName);
        }
        queryStrings.push(requiredQueryStrings);
        requestUrl += queryStrings.join("&");
        return requestUrl;
    }
    static getSignalEntityUrl(baseUrl, requiredQueryStrings, entityName, entityKey, operationName, taskHubName, connectionName) {
        let requestUrl = baseUrl + "/entities/" + entityName + "/" + entityKey + "?";
        const queryStrings = [];
        if (operationName) {
            queryStrings.push("op=" + operationName);
        }
        if (taskHubName) {
            queryStrings.push("taskHub=" + taskHubName);
        }
        if (connectionName) {
            queryStrings.push("connection=" + connectionName);
        }
        queryStrings.push(requiredQueryStrings);
        requestUrl += queryStrings.join("&");
        return requestUrl;
    }
}
exports.WebhookUtils = WebhookUtils;
//# sourceMappingURL=webhookutils.js.map